import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import TablaIcon from '../components/TablaIcon';

const D = {
  bg: '#0e0e0d', surface: '#111110', border: '#2a2927',
  accent: '#c49a3c', text: '#f0ede8', text2: '#a8a49e', text3: '#6b6966',
  input: { background: '#1c1b19', border: '1px solid #2a2927', borderRadius: '8px',
    padding: '10px 14px', color: '#f0ede8', fontSize: '14px', width: '100%',
    fontFamily: "'DM Sans', sans-serif", outline: 'none', boxSizing: 'border-box' },
  btn: { background: '#c49a3c', color: '#0e0e0d', border: 'none', borderRadius: '8px',
    padding: '11px 20px', fontSize: '14px', fontWeight: 600, cursor: 'pointer',
    width: '100%', fontFamily: "'DM Sans', sans-serif" },
};

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password,  setPassword]  = useState('');
  const [confirm,   setConfirm]   = useState('');
  const [loading,   setLoading]   = useState(false);
  const [msg,       setMsg]       = useState('');
  const [err,       setErr]       = useState('');
  const [done,      setDone]      = useState(false);

  useEffect(() => {
    if (!token) setErr('Invalid reset link. Please request a new one.');
  }, [token]);

  const handle = async () => {
    setErr(''); setMsg('');
    if (!password) return setErr('Please enter a new password.');
    if (password.length < 6) return setErr('Password must be at least 6 characters.');
    if (password !== confirm) return setErr('Passwords do not match.');
    setLoading(true);
    try {
      const r = await axios.post('/api/auth/reset-password', { token, password });
      setMsg(r.data.message);
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch(e) {
      setErr(e.response?.data?.error || 'Failed to reset password. The link may have expired.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: D.bg, display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: '24px', fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>

        <div style={{ textAlign: 'center', marginBottom: '32px', cursor: 'pointer' }}
          onClick={() => navigate('/')}>
          <TablaIcon size={40} color={D.accent}/>
          <div style={{ fontSize: '20px', fontWeight: 600, color: D.text, marginTop: '10px' }}>RhythMicky Beats</div>
          <div style={{ fontSize: '12px', color: D.text3, marginTop: '4px' }}>Reset Password</div>
        </div>

        <div style={{ background: D.surface, border: `1px solid ${D.border}`, borderRadius: '14px', padding: '28px' }}>
          {done ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '40px', marginBottom: '12px' }}>✓</div>
              <p style={{ color: '#6bff6b', fontSize: '14px', margin: '0 0 8px' }}>{msg}</p>
              <p style={{ color: D.text3, fontSize: '13px' }}>Redirecting to login...</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <p style={{ fontSize: '13px', color: D.text2, margin: 0, lineHeight: 1.6 }}>
                Enter your new password below.
              </p>
              <input style={D.input} type="password" placeholder="New password (min. 6 characters)"
                value={password} onChange={e => setPassword(e.target.value)}/>
              <input style={D.input} type="password" placeholder="Confirm new password"
                value={confirm} onChange={e => setConfirm(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handle()}/>
              {err && <div style={{ background: '#2a1515', border: '1px solid #5a2020', borderRadius: '8px',
                padding: '10px 14px', fontSize: '13px', color: '#ff6b6b' }}>{err}</div>}
              {msg && <div style={{ background: '#1a2a1a', border: '1px solid #2a5a2a', borderRadius: '8px',
                padding: '10px 14px', fontSize: '13px', color: '#6bff6b' }}>✓ {msg}</div>}
              <button style={{ ...D.btn, opacity: !token ? 0.5 : 1 }}
                onClick={handle} disabled={loading || !token}>
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
              <button onClick={() => navigate('/login')}
                style={{ background: 'none', border: 'none', color: D.text3, fontSize: '13px',
                  cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", padding: '4px' }}>
                ← Back to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
